import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditMergeNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeEditMergeNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeEditMergeNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
   ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [ 'data_store', 'data_management' ],
    properties: {
        'data_store': {
            'type': 'string',
            title: 'Data Input',
            'description': 'Location of data to merge'
        },
        merge_type: {
            title: "Merge Type",
            type: 'string',
            enum: [
                'Append',
                'Combine'
            ],
            default: "Append",
        },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Where to store any merged data for the next node'
        }
    },
    allOf: [
        {
            if: {
                properties: {
                    merge_type: {
                        const: "Append"
                    }
                }
            },
            then: {
                properties: {
                    merge_type: {
                        description: 'Each selected Data Input will be added to the end of the merged data.'
                    },
                    merge_from_data: {
                        title: 'Starting Data',
                        type: 'string',
                        description: 'Select which data field to start merging from'
                    },
                },
                required: [ 'merge_from_data' ]
            }
        },
        {
            if: {
                properties: {
                    merge_type: {
                        const: "Combine"
                    }
                }
            },
            then: {
                properties: {
                    merge_type: {
                        description: 'Each selected Data Input will be merged '
                    },
                    include_duplicates: {
                        title: 'Include Duplicates',
                        type: 'boolean',
                        description: "Select to include any duplicate values from the merged data",
                        default: false
                    },
                }
            }
        }
    ]
}


export const nodeDescription: string = "This node is used to merge data from multiple sources into a single Data Slot.\n";